import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';

import Header from '../components/Header.js'
import Footer from '../components/Footer.js'

import { YMInitializer } from 'react-yandex-metrika';

import '../scss/layout.scss';

export default class Template extends React.Component {
  static propTypes = {
    children: PropTypes.func,
  };

  render() {
    const { location } = this.props;

    const isRoot = location.pathname === '/';

    return (
      <div className="layout">
        <Helmet
          title="DenisBorodin.com"
          meta={[
            { name: 'description', content: 'Денис Бородин' },
            { name: 'keywords', content: 'Денис, Бородин, блог, фотографии' },
          ]}
        />
        <Helmet>
          <title>DenisBorodin.com</title>
          <link rel="icon" sizes="16x16" href="/favicon.png" />
          <meta name="description" content="Денис Бородин" />
          <meta name="keywords" content="Денис, Бородин, блог, фотографии" />
        </Helmet>
        <Header />
        <main className="content">
          {this.props.children()}
        </main>
        <Footer />
        <YMInitializer accounts={[47852972]} version="2" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/index.js